export interface CatalogueSelection {
  setId?: string
  sectionId?: string
}

export function selectionFromSlug(
  slug: string | string[] | undefined,
): CatalogueSelection {
  const parts = (Array.isArray(slug) ? slug : slug ? [slug] : [])
    .map((p) => decodeURIComponent(p))
    .filter(Boolean)

  return { setId: parts[0], sectionId: parts[1] }
}

/**
 * Paths under `/avatar-catalogue/` that are real pages. A set whose id matched one would be
 * shadowed by that page, so it is selected in state and simply not written to the URL.
 */
export const RESERVED_SET_IDS: readonly string[] = ['publish', 'tiers']

export const isReservedSetId = (setId?: string): boolean =>
  Boolean(setId) && RESERVED_SET_IDS.includes(setId as string)

export function slugFromSelection({
  setId,
  sectionId,
}: CatalogueSelection): string {
  if (!setId || isReservedSetId(setId)) {
    return '/avatar-catalogue'
  }
  const parts = sectionId ? [setId, sectionId] : [setId]

  return `/avatar-catalogue/${parts.map(encodeURIComponent).join('/')}`
}
